import { websiteIsValid } from "../../../../logic/RegexValidation";
import { ORGANIZATION_DESCRIPTION_MAX_LENGTH, ORGANIZATION_MISSION_MAX_LENGTH } from "../../../../logic/ValidationChecks/FieldLengths";
import { getFieldRequiredValidationCheck, getMaxLengthValidationCheck, getStringErrors, getValidationErrorDictionary, getValidationErrors } from "../../../../logic/ValidationChecks/Validation";
import { ValidationCheck } from "../../../../stores/models/ValidationCheck";
import { ValidationError } from "../../../../stores/models/ValidationError";
import { SecondaryOrganizationDetailsStepValues } from "../_interfaces/IOrganizationSignUpStepTypeValues";

const validationChecks: (stepValues: SecondaryOrganizationDetailsStepValues) => ValidationCheck<SecondaryOrganizationDetailsStepValues>[] =
    (stepValues) => {
        let checks: ValidationCheck<SecondaryOrganizationDetailsStepValues>[] = [
            getFieldRequiredValidationCheck(stepValues.description, 'description', `Please enter a description for your organization.`),
            getMaxLengthValidationCheck(stepValues.description, 'description', ORGANIZATION_DESCRIPTION_MAX_LENGTH),
            {
                name: 'valid website',
                condition: (stepValues: SecondaryOrganizationDetailsStepValues) => websiteIsValid(stepValues.website),
                error: new ValidationError(`Please enter a valid website.`, ['website'])
            }
        ];
        if (!stepValues.isForProfit) {
            checks.push(
                getFieldRequiredValidationCheck(stepValues.mission, 'mission', `Please enter your organization's mission.`),
                getMaxLengthValidationCheck(stepValues.mission, 'mission', ORGANIZATION_MISSION_MAX_LENGTH),
            )
        }
        return checks;
    };

export const OrganizationSecondaryDetailsValidation = (stepValues: SecondaryOrganizationDetailsStepValues) => {
    return {
        errors: getStringErrors(getValidationErrorDictionary(validationChecks, stepValues)),
        valid: getValidationErrors(validationChecks, stepValues).length === 0
    }
}